const r = {
  "roche-grid-1-4-1-6": "1-4-1-6",
  "roche-grid-12": "12",
  "roche-grid-3-1-5-3": "3-1-5-3",
  "roche-grid-3-1-8": "3-1-8",
  "roche-grid-3-3-3-3": "3-3-3-3",
  "roche-grid-4-4-4": "4-4-4",
  "roche-grid-4-8": "4-8",
  "roche-grid-5-1-6": "5-1-6",
  "roche-grid-5-7": "5-7",
  "roche-grid-6-1-4-1": "6-1-4-1",
  "roche-grid-6-6": "6-6",
  "roche-grid-7-5": "7-5",
  "roche-grid-8-4": "8-4",
  "roche-grid-8": "8",
  "roche-grid-6": "6",
  "roche-grid-6-1-5": "6-1-5",
  "roche-grid-8-1-3": "8-1-3",
  "roche-grid-7-1-4": "7-1-4"
}, e = {
  1: ["full"],
  2: ["left", "right"],
  3: ["left", "center", "right"],
  4: ["left", "center-left", "center-right", "right"]
};
export {
  r as gridLayoutMap,
  e as gridSlotNames
};
